import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const CustomButton = styled(ButtonMui)`
  width: 14rem;
`

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const SubContainerButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: auto;
  gap: 1rem;
`
